/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { DailyActivityMonitoringLogStatusDto } from './dailyActivityMonitoringLogStatusDto.schema';

export const IReadOnlyListOfDailyActivityMonitoringLogStatusDto = zod.array(zod.lazy(() => DailyActivityMonitoringLogStatusDto));

export type IReadOnlyListOfDailyActivityMonitoringLogStatusDto = zod.input<typeof IReadOnlyListOfDailyActivityMonitoringLogStatusDto>;
export type IReadOnlyListOfDailyActivityMonitoringLogStatusDtoOutput = zod.output<typeof IReadOnlyListOfDailyActivityMonitoringLogStatusDto>;
